import React from 'react';
import { ReportingContainerBaseConfig } from '../../../base';
import { RecordEditController } from './recordEditInterface';
import { RecordEditLoader } from './recordEditInterface';
import { RecordEditContainerProps, RecordEditViewProps } from './recordEditProps';
import { RecordFormService } from '../form';

export function createRecordEditContainer(
    config: ReportingContainerBaseConfig & {
        service: {
            record: {
                form: RecordFormService;
            };
        };
    },
    loader: RecordEditLoader,
    controller: RecordEditController,
    View: React.FC<RecordEditViewProps>
): React.FC<RecordEditContainerProps> {
    const {
        kernel: {
            infra: {
                toaster: { useToast },
            },
        },
        repository: { research: repository },
        context: { useContext },
        service: {
            record: { form: recordFormService },
        },
    } = config;

    return (containerProps) => {
        const toast = useToast();
        const context = useContext();
        const mutation = {
            record: {
                update: repository.record.useUpdate(context),
            },
        };
        const data = loader.useLoad(context, {
            document: {
                id: containerProps.document.id,
            },
        });

        const service = recordFormService.useProps(context, data.form);

        const values = service.form.watch();
        const props = controller.useProps(context, data, {
            form: {
                values,
                form: {
                    id: 'record-edit',
                    form: service.form,
                    async onSubmit(values) {
                        console.log('data', values);
                        const response = await mutation.record.update.mutateAsync([
                            data.form.record.id,
                            {
                                title: values.title ?? undefined,
                                properties: values.properties,
                            },
                        ]);
                        console.log('response', response);
                        service.form.reset();
                        containerProps.onClose();
                        toast({
                            kind: 'success',
                            description: 'Record updated',
                        });
                    },
                    onSubmitError(error) {
                        console.error('submit error', error);
                        toast({
                            kind: 'error',
                            description: 'Error updating record',
                        });
                    },
                    onError(error) {
                        console.error('form error', error);
                        toast({
                            kind: 'error',
                            description: 'Invalid form data',
                        });
                    },
                },
                property: {
                    value: service.fields.properties.value,
                    onChange(value) {
                        service.fields.properties.onChange(value);
                    },
                },
            },
        });
        return <View {...props} />;
    };
}
